export default __webpack_public_path__ + "static/media/home.be8481e5.svg";